import { useState } from "react";
import Sidebar from "./components/Sidebar";
import Dashboard from "./components/Dashboard";
import ClientManagement from "./components/ClientManagement";
import CalendarSystem from "./components/CalendarSystem";
import ServiceManagement from "./components/ServiceManagement";
import WorkTracking from "./components/WorkTracking";

type Section = "dashboard" | "clients" | "calendar" | "services" | "tracking";

export default function Home() {
  const [activeSection, setActiveSection] = useState<Section>("dashboard");

  const renderSection = () => {
    switch (activeSection) {
      case "dashboard": return <Dashboard />;
      case "clients": return <ClientManagement />;
      case "calendar": return <CalendarSystem />;
      case "services": return <ServiceManagement />;
      case "tracking": return <WorkTracking />;
      default: return <Dashboard />;
    }
  };

  return (
    <div
      className="flex h-screen overflow-hidden"
      style={{
        background: "radial-gradient(ellipse at 20% 50%, rgba(120,50,180,0.35) 0%, transparent 55%), radial-gradient(ellipse at 80% 20%, rgba(212,175,55,0.18) 0%, transparent 50%), radial-gradient(ellipse at 60% 80%, rgba(88,28,135,0.25) 0%, transparent 50%), #1c1840",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Background stars effect */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden" style={{ zIndex: 0 }}>
        {[...Array(40)].map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full"
            style={{
              width: Math.random() * 2 + 1 + "px",
              height: Math.random() * 2 + 1 + "px",
              left: Math.random() * 100 + "%",
              top: Math.random() * 100 + "%",
              background: i % 3 === 0 ? "rgba(212,175,55,0.6)" : "rgba(255,255,255,0.25)",
              animation: `twinkle ${2 + Math.random() * 3}s ease-in-out infinite`,
              animationDelay: Math.random() * 4 + "s",
            }}
          />
        ))}
      </div>

      {/* Sidebar */}
      <div className="relative z-10">
        <Sidebar activeSection={activeSection} onSectionChange={(s) => setActiveSection(s as Section)} />
      </div>

      {/* Main Content */}
      <main className="flex-1 overflow-hidden relative z-10">
        {renderSection()}
      </main>

      <style>{`
        @keyframes twinkle {
          0%, 100% { opacity: 0.2; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.3); }
        }
      `}</style>
    </div>
  );
}
